import MedianAlpha from './MedianAlpha';

export default MedianAlpha;
